import axios from 'axios'
import toast from 'react-hot-toast'

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL || 'http://localhost:8000'}/api/v1`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 90000,  // 90s to handle Render free-tier cold starts (~50s)
})

// ── Clerk token getter (set by ClerkTokenSync in App.jsx) ─────────────────────
let _clerkGetToken = null
export function setClerkGetToken(fn) {
  _clerkGetToken = fn
}

// ── Request interceptor — attach Clerk token + track slow requests ───────────
let _wakeupToastId = null

api.interceptors.request.use(
  async (config) => {
    if (_clerkGetToken) {
      const token = await _clerkGetToken()
      if (token) config.headers.Authorization = `Bearer ${token}`
    }
    // Show "waking up" notice for requests that might hit a cold server
    config._startTime = Date.now()
    config._wakeupTimer = setTimeout(() => {
      _wakeupToastId = toast.loading('Waking up server (first request may take ~30s)…', { id: 'server-wakeup' })
    }, 8000)
    return config
  },
  (error) => Promise.reject(error)
)

// ── Response interceptor — dismiss wakeup toast + handle errors ───────────────
api.interceptors.response.use(
  (response) => {
    clearTimeout(response.config._wakeupTimer)
    toast.dismiss('server-wakeup')
    return response
  },
  (error) => {
    if (error.config?._wakeupTimer) clearTimeout(error.config._wakeupTimer)
    toast.dismiss('server-wakeup')
    return Promise.reject(error)
  }
)

export default api
